import React, { useState, useRef, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text,
    InputGroup, InputRightElement, Icon, IconButton,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, ModalFooter,
    Textarea, Select
} from '@chakra-ui/react';
import { MdSave } from 'react-icons/md';
import { Form, Field } from 'react-final-form';
import { FLOOR_LIST } from '../../../constants';

function AddEditDepartmentModal({ 
    company_id, departmentDetail, actionStatus, initialRef, isOpen, onClose, 
    apiCreateNewDepartment, apiUpdateADepartment,
}) {
    const [ cookies ] = useCookies(["loginCookie"]);
    const [ isProcessing, setIsProcessing ] = useState(false);

    useEffect(() => {
        if(!actionStatus) {
            setIsProcessing(false);
        }
    }, [actionStatus]);

    const validate = (values) => {
        const errors = {};

        if(!values.name) {
            errors.name = "Required";
        }
        if(!values.specialist) {
            errors.specialist = "Required";
        }
        if(!values.location) {
            errors.location = "Required";
        }

        return errors;
    }

    const onSubmit = async(values) => {
        setIsProcessing(true);

        if(departmentDetail && departmentDetail.id) {
            apiUpdateADepartment({ 
                id: departmentDetail.id, 
                payload: {
                    ...values,
                    user_id: cookies?.loginCookie?.data?.id,   
                }
            });
        } else {
            apiCreateNewDepartment({ 
                ...values, 
                user_id: cookies?.loginCookie?.data?.id,
            });
        }
    }

    return (
        <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} size="md">
            <ModalOverlay />
            <Form
                onSubmit={onSubmit}
                initialValues={{
                    company_id,
                    ...departmentDetail
                }}
                validate={validate}
                render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <ModalContent>
                                <ModalHeader>
                                    { departmentDetail && departmentDetail.id ? "CẬP NHẬT" : "TẠO MỚI" }
                                </ModalHeader>
                                <ModalCloseButton />

                                <ModalBody pb={6}>
                                    <Field name="name">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Tên phòng</FormLabel>
                                                <Input {...input} type='text' placeholder='Nhập tên phòng' />
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="specialist">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Chuyên khoa</FormLabel>
                                                <Input {...input} type='text' placeholder='Nhập Chuyên khoa' />
                                            </FormControl>
                                        )}
                                    </Field>
       
                                    <Field name="location">
                                        {({ input, meta }) => (
                                            <FormControl mt={4} isRequired>
                                                <FormLabel>Vị trí</FormLabel>
                                                <Select {...input} placeholder='Chọn vị trí'>
                                                    {
                                                        Object.keys(FLOOR_LIST).map(key => (
                                                            <React.Fragment key={key}>
                                                                <option value={key}>{FLOOR_LIST[key]}</option>
                                                            </React.Fragment>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="description">
                                        {({ input, meta }) => (
                                            <FormControl mt={4}>
                                                <FormLabel>Mô tả thêm</FormLabel>
                                                <Textarea {...input} placeholder='Nhập mô tả thêm' />
                                            </FormControl> 
                                        )}
                                    </Field>
                                </ModalBody>

                                <ModalFooter>
                                    <Button colorScheme='blue' mr={3} type='submit' isDisabled={!valid || pristine}
                                        isLoading={isProcessing}
                                        loadingText="Đang lưu"
                                    >
                                        <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                        <Text fontSize="14px">Lưu</Text>
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </form>
                    )
                }}
            />
        </Modal>
    )
}

export default AddEditDepartmentModal;